<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="unreadAlert.total_count" />

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ unreadAlert.total_count }}</h3>
        <p class="opacity-75">새로운 알림</p>
      </div>

      <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
        <ul class="bordered-items">
          <li v-for="ntf in alertList" :key="ntf.index"
              class="flex justify-between px-4 py-4 notification cursor-pointer"
              :class="{'read': ntf.read}"
              @click="()=>{handleClickAlertDetail(ntf)}">
            <div class="flex items-start">
              <feather-icon :icon="ntf.icon" :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
              <div class="mx-2">
                <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.title }}</span>
                <small>{{ ntf.msg }}</small>
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap">{{ DateUtil.elapsedTime(ntf.time) }}</small>
          </li>
        </ul>
      </component>

      <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        w-full
        p-2

        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light">
        <span class="cursor-pointer hover:font-semibold" @click="handleMoveAlert">모든 알림 보기</span>
        <span class="mx-2" style="color: #757575">|</span>
        <span class="cursor-pointer hover:font-semibold" style="color: #3c3c3c" @click="handleReadAlertAll">모든 알림 확인처리</span>
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import DateUtil from "../../../../util/DateUtil";

export default {
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    DateUtil() {
      return DateUtil
    },
    projectId () {
      return this.$route.params.proj_id
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },

    unreadAlert () {
      let unReadInfo = this.$store.state.approval.mainAlertUnReadInfo;
      if (unReadInfo) {
        unReadInfo = JSON.parse(JSON.stringify(this.$store.state.approval.mainAlertUnReadInfo))

        const list = []
        if (unReadInfo.data) {
          for (const alert of unReadInfo.data) {
            const data = typeof alert.data === 'string' ? JSON.parse(alert.data) : alert.data;

            const location = [];
            // const projectName = data.project_name || ''
            // if (projectName) {
            //   location.push(projectName);
            // }
            const boardName = data.board_title || ''
            if (boardName) {
              location.push(boardName);
            }

            list.push({
              index    : alert.id,
              title    : alert.message,
              msg      : location.join(' - '),
              icon     : 'AlertOctagonIcon',
              time     : alert.created_at,
              category : 'danger',
              data,
              read: false,
            })
          }

          unReadInfo.data = list
          return unReadInfo
        }
      }
      return {
        data:[],
        total_count:0
      }
    },
    readAlert () {
      let readInfo = this.$store.state.approval.mainAlertReadInfo;
      if (readInfo) {
        readInfo = JSON.parse(JSON.stringify(this.$store.state.approval.mainAlertReadInfo))
        const list = []
        if (readInfo.data) {
          // 7일 이내 읽은 알림만 보여준다
          const datas = readInfo.data.filter(alert => {
            const checkDate = new Date(alert.created_at).addDays(7)
            return checkDate - new Date() > 0;
          })

          for (const alert of datas) {
            const data = typeof alert.data === 'string' ? JSON.parse(alert.data) : alert.data;

            const location = [];
            // const projectName = data.project_name || ''
            // if (projectName) {
            //   location.push(projectName);
            // }

            const boardName = data.board_title || ''
            if (boardName) {
              location.push(boardName);
            }

            list.push({
              index    : alert.id,
              title    : alert.message,
              msg      : location.join(' - '),
              icon     : 'AlertOctagonIcon',
              time     : alert.created_at,
              category : 'danger',
              data,
              read: true,
            })
          }

          readInfo.data = list
          return readInfo
        }
      }
      return {
        data:[],
        total_count:0
      }
    },
    alertList () {
      const unread = this.unreadAlert.data
      const read = this.readAlert.data
      const all = unread.concat(read)

      return all.sort((a, b) => {
        return new Date(b.time) - new Date(a.time)
      })
    },
  },
  methods: {
    async handleMoveAlert () {
      this.loading(true);
      if (this.projectId) {
        await this.$router.push({name: 'project-mypage-alert'}).catch((err) => {
          //NavigationDuplicated 에러일 경우 무시
          if (err.name !== 'NavigationDuplicated') {
            console.error(err);
          }
        }).finally(() => {
          this.loading(false);
        })
      } else {
        await this.$router.push('/mypage/alert').catch((err) => {
          //NavigationDuplicated 에러일 경우 무시
          if (err.name !== 'NavigationDuplicated') {
            console.error(err);
          }
        }).finally(() => {
          this.loading(false);
        })
      }
    },


    async __load_alert (page, list) {
      // 강제로 호출 하기 위해 loaded_at 값을 null로 설정
      this.$store.state.approval.mainAlertUnReadInfo.loaded_at = null;
      const alert = await this.$store.dispatch("approval/LOAD_NOTIFICATION_UNREAD_LIST", {
        page_unread: page,
        per_page_unread: 5,
        days_before_unread: 30,
      });
      if (alert && alert.unread) {
        const data = alert.unread.data
        list.push(...data)
        const lastPage = alert.unread.last_page;
        if (lastPage > page) {
          await this.__load_alert(page + 1, list);
        }
      }

    },
    async handleReadAlertAll() {

      const list = [];
      await this.__load_alert(1, list)

      if (list.length > 0) {
        const ids = list.map((alert) => {
          return alert.id
        });

        if (ids.length > 0) {
          await this.$store.dispatch('approval/READ_NOTIFICATION', {ids})

          // 오른쪽 상단에 토스트 팝업을 띄움
          this.$vs.notify({
            title: '알림',
            text: '모든 알림이 확인처리 되었습니다.',
            color: 'success',
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-check'
          })

          // 강제로 호출 하기 위해 loaded_at 값을 null로 설정
          this.$store.state.approval.mainAlertUnReadInfo.loaded_at = null;
          await this.$store.dispatch("approval/LOAD_NOTIFICATION_UNREAD_LIST", {
            page_unread: 1,
            per_page_unread: 5,
            days_before_unread: 30,
          });

          // MyPageAlert 컴포넌트에 알림 데이터가 업데이트되었음을 알리는 이벤트 발행
          this.$root.$emit('notifications-updated');
        }
      }
    },

    async handleClickAlertDetail (notification) {
      if (notification.data) {
        const ids = [notification.index]
        const projectId = notification.data.project_id
        const boardId = notification.data.board_id
        const postId = notification.data.post_id

        // 페이지 이동에는 시간이 걸린다
        this.loading(true);
        // 읽은 상태로 변경
        await this.$store.dispatch('approval/READ_NOTIFICATION', {ids})
        // 강제로 알림 리스트를 다시 불러온다
        await this.$store.dispatch('approval/LOAD_NOTIFICATION_UNREAD_LIST', {
          page_unread: 1,
          per_page_unread: 5,
          days_before_unread: 30,
          isForce: true,
        })

        // MyPageAlert 컴포넌트에도 알림 데이터가 업데이트되었음을 알리는 이벤트 발행
        this.$root.$emit('notifications-updated');

        // 게시글로 이동
        await this.movePost(projectId, boardId, postId)
        this.loading(false);
      }
    },

    async movePost (projectId, boardId, postId) {

      /* 안전·보건예산 현황 */
      if (boardId === 3) { await this.$router.push({path: `/project/${projectId}/write/report/project_monthly_report/${postId}`}); return }
      /* 최초 위험성평가 */
      if (boardId === 6) { await this.$router.push({path: `/project/${projectId}/risk/assessment/first/${postId}`}); return }
      /* 정기위험성평가 */
      if (boardId === 7) { await this.$router.push({path: `/project/${projectId}/risk/assessment/regular/${postId}`}); return }
      /* 수시위험성평가 */
      if (boardId === 41) { await this.$router.push({path: `/project/${projectId}/risk/assessment/always/${postId}`}); return }
      /* 위험성평가협의회 */
      if (boardId === 8) { await this.$router.push({path: `/project/${projectId}/risk/conference/warning/${postId}`}); return }
      /* 수시 위험성평가협의회 */
      if (boardId === 42) { await this.$router.push({path: `/project/${projectId}/risk/conference/warning-always/${postId}`}); return }
      /* 산업안전보건위원회 */
      if (boardId === 9) { await this.$router.push({path: `/project/${projectId}/risk/conference/safety/${postId}`}); return }
      /* 작업허가서(내부용) */
      if (boardId === 10) { await this.$router.push({path: `/project/${projectId}/risk/permit/work/${postId}`}); return }
      /* 작업허가서(외부용) */
      if (boardId === 11) { await this.$router.push({path: `/project/${projectId}/risk/permit/work_export/${postId}`}); return }

      /* 안전점검일지 */
      if (boardId === 13) { await this.$router.push({path: `/project/${projectId}/risk/check/checklog/${postId}`}); return }
      /* 안전점검일지 */
      if (boardId === 14) { await this.$router.push({path: `/project/${projectId}/risk/check/checklogall/${postId}`}); return }
      /* 산업재해무재해 */
      if (boardId === 22) { await this.$router.push({path: `/project/${projectId}/safety/accident/report/${postId}`}); return }
      /* 안전용품 현황 */
      if (boardId === 23) { await this.$router.push({path: `/project/${projectId}/safety/supplies/${postId}`}); return }
      /* 건설장비관리 */
      if (boardId === 24) { await this.$router.push({path: `/project/${projectId}/safety/equipment/plan/${postId}`}); return }
      /* 환경일일점검 */
      if (boardId === 28) { await this.$router.push({path: `/project/${projectId}/state/check/daily/${postId}`}); return }
      /* 환경월간점검 */
      if (boardId === 29) { await this.$router.push({path: `/project/${projectId}/state/check/monthly/${postId}`}); return }
      /* 환경지원 */
      if (boardId === 30) { await this.$router.push({path: `/project/${projectId}/state/support/${postId}`}); return }
      /* 환경평가 */
      if (boardId === 31) { await this.$router.push({path: `/project/${projectId}/state/evaluation/${postId}`}); return }
      /* 환경이슈보고 */
      if (boardId === 32) { await this.$router.push({path: `/project/${projectId}/state/report/issue/${postId}`}); return }
      /* 환경사고보고 */
      if (boardId === 33) { await this.$router.push({path: `/project/${projectId}/state/report/accident/${postId}`}); return }

      /* HSE 교육관리 */
      if (boardId === 35) { await this.$router.push({path: `/project/${projectId}/hse/list/safety/${postId}`}); return }
      /* 안전요청 */
      if (boardId === 36) { await this.$router.push({path: `/project/${projectId}/prevention/request/safety/${postId}`}); return }
      /* 환경요청 */
      if (boardId === 39) { await this.$router.push({path: `/project/${projectId}/prevention/request/environment/${postId}`}); return }
      /* 보건요청 */
      if (boardId === 40) { await this.$router.push({path: `/project/${projectId}/prevention/request/health/${postId}`}); return }

      /* 사고보고 */
      if (boardId === 45) { await this.$router.push({path: `/project/${projectId}/write/accident/accident_report/${postId}`}); return }
      /* 산재검토 */
      if (boardId === 46) { await this.$router.push({path: `/project/${projectId}/write/accident/accident_review/${postId}`}); return }

      /* 444점검 */
      if (boardId === 48) { await this.$router.push({path: `/project/${projectId}/write/safety_check/safety_check_444/${postId}`}); return }
      /* 출역장비 */
      if (boardId === 49) { await this.$router.push({path: `/project/${projectId}/write/safety_check/safety_check_444/${postId}`}); return }
      /* 파트너사 계약현황 */
      if (boardId === 50) { await this.$router.push({path: `/project/${projectId}/plan/partners`}); return }
      /* 444점검 */
      if (boardId === 51) { await this.$router.push({path: `/project/${projectId}/write/safety_check_partner/safety_check_partner_444/${postId}`}); return }

      /* 사고조사 보고서 */
      if (boardId === 53) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 사고경위서 */
      if (boardId === 54) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 목격자 진술서 */
      if (boardId === 55) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 실험실 안전사고 보고 */
      if (boardId === 56) { await this.$router.push({path: `/project/${projectId}/approval/${boardId}/write/${postId}`}); return }
      /* 산업재해조사표 */
      if (boardId === 57) { await this.$router.push({path: `/project/${projectId}/normal/${boardId}/write/${postId}`}); return }
      /* 산업안전보건위원회 */
      if (boardId === 58) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전경영위원회 */
      if (boardId === 59) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전근로협의체 */
      if (boardId === 60) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전보건협의체 */
      if (boardId === 61) { await this.$router.push({path: `/project/${projectId}/normal/${boardId}/write/${postId}`}); return }
      /* 아차사고 사례 카드 */
      if (boardId === 62) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 아차사고 사례 개선 확인 카드 */
      if (boardId === 63) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 실험실 일상 점검표 */
      if (boardId === 64) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 실험실 정기 점검표 */
      if (boardId === 65) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* TAC 안전관리 점검표 */
      if (boardId === 66) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 밀폐공간 작업프로그램 평가표 */
      if (boardId === 67) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 밀폐공간 작업 전 체크리스트 */
      if (boardId === 68) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 고압가스 충전실 안전점검표 */
      if (boardId === 69) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 한수단 2호 안전점검표 */
      if (boardId === 70) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 잠수 운용 계획서 */
      if (boardId === 71) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 잠수작업 전 안전점검표 */
      if (boardId === 72) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 잠수 운용 결과서 */
      if (boardId === 73) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 중량물·운반기계 안전점검표 */
      if (boardId === 74) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업장 안전점검표 */
      if (boardId === 75) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 부적합 및 시정조치 - 안전 */
      if (boardId === 76) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 부적합 및 시정조치 - 보건 */
      if (boardId === 77) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업중지보고서 - 임직원 */
      if (boardId === 78) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업중지보고서 - 근로자 */
      if (boardId === 79) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업중지 조치결과서 - 임직원 */
      if (boardId === 80) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업중지 조치결과서 - 근로자 */
      if (boardId === 81) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 정기 위험성 평가 */
      if (boardId === 82) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 수시 위험성 평가 */
      if (boardId === 83) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전작업허가 - 작업수행부서 */
      if (boardId === 84) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전작업허가 - 수급업체 */
      if (boardId === 85) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전·보건예산 현황 */
      if (boardId === 86) { await this.$router.push({path: `/project/${projectId}/approval/${boardId}/write/${postId}`}); return }
      /* 작업중지보고서 - 기타 */
      if (boardId === 87) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업중지 조치결과서 - 기타 */
      if (boardId === 88) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }

      // BS
      if (boardId >= 100) { await this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`});  }
    },
    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },
  }
}

</script>

<style lang="scss" scoped>
.read {
  opacity: 0.5;
}
</style>

